import { render, staticRenderFns } from "./AuthorisationDetail.vue?vue&type=template&id=3ddac222&scoped=true&"
import script from "./AuthorisationDetail.vue?vue&type=script&lang=js&"
export * from "./AuthorisationDetail.vue?vue&type=script&lang=js&"
import style0 from "./AuthorisationDetail.vue?vue&type=style&index=0&id=3ddac222&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddac222",
  null
  
)

export default component.exports